import {
  ADMIN_ROUTE_NAMES,
  RETAIL_ROUTE_NAMES,
  MY_REVIEW_ROUTE_NAME,
  offersFiltersName,
} from 'utils/consts'
import { getELabelsFiltersCollection } from './eLabelsFilters'
import { getMyWinesFiltersCollection } from './myWinesFilters'
import { getCapturedWinesFiltersCollection } from './capturedWinesFilters'
import { getMyReviewsFiltersCollection } from './myReviewsFilters'
import { getDatabaseFiltersCollection } from './database'
import { getAdministrationFiltersCollection } from './administration/offers'
import { getAdministrationRequestsFiltersCollection } from './administration/requests'
import { getAdministrationRequestsPotentialProducersFiltersCollection } from './administration/potentialProducers'
import { getAdministrationCompaniesFilterCollection } from './administration/companies'
import { getAdministrationElabelsFilterCollection } from './administration/elabels'
import { getAdministrationUsersFiltersCollection } from './administration/users'
import { getAdministrationTradeOffersFiltersCollection } from './administration/tradeOffers'
import { getAdministrationPriceSourcesFiltersCollection } from './administration/priceSources'
import { getAdministrationWineSitesFiltersCollection } from './administration/wineSites'
import { getAdministrationMentionsFiltersCollection } from './administration/mentions'
import { getAdministrationMentionsFactsFiltersCollection } from './administration/mentionsFacts'
import { getAdministrationLinkMentionsFiltersCollection } from './administration/linkMentions'
import { getAdministrationClustersFiltersCollection } from './administration/clusters'
import { getAdministrationRetailPublicPagesFiltersCollection } from './administration/retailPublicPages'
import { getAdministrationMentionsPricesFiltersCollection } from './administration/mentionsPrices'
import { getAdministrationVerifiedRelationsFiltersCollection } from './administration/verifiedRelations'
import { getBuyWineAnalysisRatingFiltersCollection } from './buyWineAnalysisRatingFilters'
import { getBuyWineWinesFiltersCollection } from './buyWineWinesFilters'
import { getBuyWineOffersFiltersCollection } from './buyWineOffersFilters'
import { sellWineMyOffersFiltersCollection } from './sellWineMyOffersFilters'
import { getRetailEShopsFiltersCollection } from './retail/eshops'
import { getRetailWinesFiltersCollection } from './retail/wines'
import { getRetailGIFiltersCollection } from './retail/geoIndications'
import { getRetailPriceReportFiltersCollection } from './retail/priceReport'
import { getBuyWineAnalysisOffersFiltersCollection } from './buyWineAnalysisOffersFilters'
import { getDefaultOffersFiltersCollection } from './defaultOffersFilters'

export type FiltersCollectionItem = {
  type: string
  title: string
  filterName: string
  apiFilterName: string
  switchType?: string
  switchFilterName?: string
  switchTitle?: string
  switchApiFilterName?: string
  withCheckAll?: boolean
  notUseLastUpdatedFilter?: boolean
  showCount?: boolean
  fixedToDate?: Date
  maxDate?: Date | null
  defaultIntervalKey?: string
}

export type FiltersCollection = FiltersCollectionItem[]

// Реестр: storeName -> функция, возвращающая коллекцию фильтров.
// Чтобы добавить раздел — допиши одну запись здесь.
export const filtersCollectionsRegistry: Record<
  string,
  () => FiltersCollection
> = {
  accBuyWineAnalysis: getBuyWineAnalysisOffersFiltersCollection,
  accBuyWineAnalysisRating: getBuyWineAnalysisRatingFiltersCollection,
  accBuyWineOffers: getBuyWineOffersFiltersCollection,
  accBuyWineWines: getBuyWineWinesFiltersCollection,
  accSellWineMyOffers: sellWineMyOffersFiltersCollection,

  accELabels: getELabelsFiltersCollection,
  accMyWinesWines: getMyWinesFiltersCollection,
  accMyWinesWinesAll: getMyWinesFiltersCollection,
  accMyWinesWinesShortlist: getMyWinesFiltersCollection,
  accCapturedWines: getCapturedWinesFiltersCollection,
  accCapturedWinesAll: getCapturedWinesFiltersCollection,
  accCapturedWinesShortlist: getCapturedWinesFiltersCollection,
  accDatabaseBrands: getDatabaseFiltersCollection,
  accDatabaseWines: getDatabaseFiltersCollection,
  accDatabaseProducers: getDatabaseFiltersCollection,
  accDatabaseGeoIndication: getDatabaseFiltersCollection,
  accDatabaseProducersDuplicates: getDatabaseFiltersCollection,
  accDatabaseExhibitions: getDatabaseFiltersCollection,
  accDatabaseKindOfWine: getDatabaseFiltersCollection,
  accDatabaseSpecialClassificationCondition: getDatabaseFiltersCollection,
  [MY_REVIEW_ROUTE_NAME]: getMyReviewsFiltersCollection,
  [ADMIN_ROUTE_NAMES.adminReviews]: getMyReviewsFiltersCollection,

  [RETAIL_ROUTE_NAMES.retailBuyersWine]: () =>
    getBuyWineWinesFiltersCollection().filter(
      item => item.filterName !== offersFiltersName.onlyWithOffersFilter
    ),
  [RETAIL_ROUTE_NAMES.retailEShops]: getRetailEShopsFiltersCollection,
  [RETAIL_ROUTE_NAMES.retailWines]: getRetailWinesFiltersCollection,
  [RETAIL_ROUTE_NAMES.myRange]: getRetailWinesFiltersCollection,
  [RETAIL_ROUTE_NAMES.retailPriceReport]: getRetailPriceReportFiltersCollection,
  [RETAIL_ROUTE_NAMES.retailGeoIndications]: getRetailGIFiltersCollection,

  [ADMIN_ROUTE_NAMES.adminOffers]: getAdministrationFiltersCollection,
  [ADMIN_ROUTE_NAMES.adminElabels]: getAdministrationElabelsFilterCollection,
  [ADMIN_ROUTE_NAMES.adminCompanies]:
    getAdministrationCompaniesFilterCollection,
  [ADMIN_ROUTE_NAMES.adminRequests]: getAdministrationRequestsFiltersCollection,
  [ADMIN_ROUTE_NAMES.potentialProducers]:
    getAdministrationRequestsPotentialProducersFiltersCollection,
  [ADMIN_ROUTE_NAMES.adminUsers]: getAdministrationUsersFiltersCollection,
  [ADMIN_ROUTE_NAMES.adminTradeOffers]:
    getAdministrationTradeOffersFiltersCollection,
  [ADMIN_ROUTE_NAMES.adminRetailPublicPages]:
    getAdministrationRetailPublicPagesFiltersCollection,
  [ADMIN_ROUTE_NAMES.adminPriceSources]:
    getAdministrationPriceSourcesFiltersCollection,
  [ADMIN_ROUTE_NAMES.adminWineSites]:
    getAdministrationWineSitesFiltersCollection,
  [ADMIN_ROUTE_NAMES.adminMentions]: getAdministrationMentionsFiltersCollection,
  [ADMIN_ROUTE_NAMES.adminMentionsFacts]:
    getAdministrationMentionsFactsFiltersCollection,
  [ADMIN_ROUTE_NAMES.adminMentionsPrices]:
    getAdministrationMentionsPricesFiltersCollection,
  [ADMIN_ROUTE_NAMES.adminLinkMentions]:
    getAdministrationLinkMentionsFiltersCollection,
  [ADMIN_ROUTE_NAMES.adminClusters]: getAdministrationClustersFiltersCollection,
  [ADMIN_ROUTE_NAMES.adminVerifiedRelations]:
    getAdministrationVerifiedRelationsFiltersCollection,
}

export const getFiltersCollection = (storeName?: string): FiltersCollection => {
  const resolver = filtersCollectionsRegistry[storeName ?? '']
  return resolver ? resolver() : getDefaultOffersFiltersCollection()
}
